const ACTIVITY_URL = (window.location.host == 'mtest.thecover.cn' || window.location.port) ? 'https://demo-actapi.fm-dev.thecover.cn' : 'https://actapi.thepage.cn';

export default {
    HTTP_URL: 'https://api.thecover.cn', // 封面新闻接口地址 
    // HTTP_URL: 'https://cover-api.test.thecover.cn', // 封面新闻接口测试地址 
    ACTIVITY_URL: ACTIVITY_URL, // 活动接口地址
    // ACTIVITY_URL: 'https://demo-actapi.fm-dev.thecover.cn', // 活动接口测试地址
    TRACK_URL: 'https://yun.thecover.cn/fmio/web/receive', // 数据部埋点接口地址
    UNIVERSALLINK: 'https://wapcdn.thecover.cn/UniversalLinks/index.html', // UniversalLink地址
    WEXIN_APP_DOWNLOAD_ADDRESS: "http://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia", // 微信应用宝地址
	APP_SCHEME_URL: "cover://cn.thecover.www", // scheme地址
    ApiToken: sessionStorage.getItem('TOKEN'),
    Api_sign_root: '12345678',
    wx_appid: 'wx1294924fd43f1119',
    timestamp: new Date().getTime(), // 当前时间戳
    DOWNLOAD_ADDRESS: 'https://api.thecover.cn/download.js'
}
